import React, { useContext, useState } from "react";
import { MessageDocumentTypeEnum, MessageDocumentTypes } from "./types";
import {
  Box,
  Button,
  Dialog,
  Radio,
  RadioGroup,
  Stack,
} from "@origin-digital/ods-core";
import { MessageContext } from "./MessageContext";

const FileTypeDialog = () => {
  const [missingOption, setMissingOption] = useState(false);
  const { messageTabState, setMessageTabState } = useContext(MessageContext);
  const { selectedAttachments } = messageTabState;

  const onDocumentTypeSelected = (type: MessageDocumentTypeEnum) => {
    setMissingOption(false);
    const lastAttachment = selectedAttachments.pop();
    if (lastAttachment) {
      lastAttachment.fileUploadType = type;
      setMessageTabState((prevMessageTabState) => ({
        ...prevMessageTabState,
        selectedAttachments: [...selectedAttachments, lastAttachment],
      }));
    }
  };

  const onCancel = () => {
    setMissingOption(false);
    selectedAttachments.pop();
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      selectedAttachments,
      showDocumentTypeDialog: false,
    }));
  };

  const onAttach = () => {
    if (!selectedAttachments[selectedAttachments.length - 1].fileUploadType) {
      setMissingOption(true);
      return;
    }
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      showDocumentTypeDialog: false,
    }));
  };

  return (
    <Dialog id="dialog" open={true} title="File type" onClose={onCancel}>
      {/* Container */}
      <Stack
        space={{
          xs: "large",
          lg: "xlarge",
        }}
      >
        {/* File types */}
        <RadioGroup
          name="filetypes"
          label="Choose a file type"
          helperText={
            missingOption
              ? "Please select"
              : "Files are stored with a request. They are visible to all users with access to this request"
          }
          error={missingOption}
        >
          {Object.values(MessageDocumentTypes).map((documentType) => (
            <Radio
              key={documentType.type}
              id={documentType.type}
              label={documentType.label}
              value={documentType.type}
              onChange={() => onDocumentTypeSelected(documentType.type)}
            />
          ))}
        </RadioGroup>
        {/* End File types */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "medium",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            /*@ts-expect-error: it works but throws error in ts*/
            flexWrap={{
              lg: "noWrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box display="flex">
              <Box marginRight="large">
                <Button variant="text" color="primary" onClick={onCancel}>
                  Cancel
                </Button>
              </Box>
              <Button onClick={onAttach}>Attach</Button>
            </Box>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
      {/* End Container */}
    </Dialog>
  );
};

export default FileTypeDialog;
